import type { Enum } from './enum.types';

export const MediaAssetServiceStatus = {
  AVAILABLE: 'AVAILABLE',
  RESTRICTED: 'RESTRICTED',
} as const;
export type MediaAssetServiceStatus = Enum<typeof MediaAssetServiceStatus>;

export type MediaAssetServiceResponse = {
  mediaAssetId: string;
  status: MediaAssetServiceStatus;
  availableAt?: string;
  hlsStreamUrl?: string;
};
